import {
  APPLICATION_REVIEW_LOADING_STATUS_UPDATE,
  ENROLLMENT_LOADING_STATUS_UPDATE,
  LISTING_APPLICATIONS_TAB_LOADING_STATUS_UPDATE,
  UPDATE_REPORTS_LOADING_STATUSES,
} from '../constants/actionTypes';

function listingApplicationsTabLoadingStatusUpdate(payload) {
  return { type: LISTING_APPLICATIONS_TAB_LOADING_STATUS_UPDATE, payload };
}

function applicationReviewLoadingStatusUpdate(payload) {
  return { type: APPLICATION_REVIEW_LOADING_STATUS_UPDATE, payload };
}

function updateReportsLoadingStatuses(payload) {
  return { type: UPDATE_REPORTS_LOADING_STATUSES, payload };
}

function enrollmentLoadingStatusUpdate(payload) {
  return { type: ENROLLMENT_LOADING_STATUS_UPDATE, payload };
}

export {
  listingApplicationsTabLoadingStatusUpdate,
  applicationReviewLoadingStatusUpdate,
  updateReportsLoadingStatuses,
  enrollmentLoadingStatusUpdate,
};
